import categorySlice from "../pages/afterAuth/courses/CourseCategories/categorySlice";
import studentReducer from "../pages/afterAuth/userManagement/students/redux/reducer";
import subAdminReducer from "../pages/afterAuth/userManagement/subAdmin/SubAdmin.slice";
import loginReducer from "../pages/beforeAuth/login/redux/reducer";
import courseReducer from "../pages/afterAuth/courses/redux/reducer";
import blogreducer from "../pages/afterAuth/blogMore/redux/reducer";
import enrolledStudentsReducer from "../pages/afterAuth/courses/EnrolledStudents/redux/reducer";
import batchOverviewReducer from "../pages/afterAuth/batch/batchOverview/redux/reducer";
import WebinarSlice from "../pages/afterAuth/webinar/Webinar.Slice";
import announcementReducer from "../pages/afterAuth/queryAnnouncement/announcement/redux/reducer";
import batchSessionManagementSlice from "./slices/session-management.slice";
import TrainerSlice from "../pages/afterAuth/userManagement/trainers/redux/reducer";
import notificationSlice from "./slices/notification.slice";
import roiSlice from "./slices/roi.slice";
import offerReducer from "../pages/afterAuth/offers/redux/reducer";
import offerDetailsReducer from "../pages/afterAuth/offers/OfferDetails/redux/reducer";
import careerSlice from "../pages/afterAuth/careers/companyRole/redux/reducer";


export const rootReducer = {
  trainer: TrainerSlice,
  student: studentReducer,
  login: loginReducer,
  subAdmin: subAdminReducer,
  career: careerSlice,
  course: courseReducer,
  category: categorySlice,
  blog: blogreducer,
  enrolledStudents: enrolledStudentsReducer,
  batchOveriew: batchOverviewReducer,
  webinarList: WebinarSlice,
  announcement: announcementReducer,
  batchSessionManagement: batchSessionManagementSlice,
  notification: notificationSlice,
  roi: roiSlice,
  offers: offerReducer,
  offerDetails: offerDetailsReducer,
};
